import { Directive, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ColumnSortService, ColumnSortedEvent } from '../services/column-sort.service';

@Directive( {
  selector: '[sortable-table]'
} )
export class SortableTableDirective implements OnInit, OnDestroy {
  constructor( private sortService: ColumnSortService ) { }

  @Output()
  sorted = new EventEmitter<any>();

  private columnSortedSubscription: Subscription;

  ngOnInit() {
    this.columnSortedSubscription = this.sortService.columnSorted$.subscribe( event => {
      this.sorted.emit( event );
    } );
  }

  ngOnDestroy() {
    this.columnSortedSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/sortable-table.directive.ts